<app-background-glitch [images]="backgroundImages()" />

@if (data$ | async; as data) {
<div class="content relative flex flex-col">
  <app-header [site]="{ title: data.shortTitle, logo: data.logo }" />

  <div class="flex flex-col justify-center flex-1 h-full">
    <div [hidden]="!contentView()">
      <router-outlet #outlet="outlet" />
    </div>

    <button (click)="toggleContentView()" class="fixed bottom-5 left-5 z-30 cursor-pointer ml-auto has-tooltip" aria-label="Toggle content visibility">
      <span class="tooltip rounded shadow-lg p-2 bg-white bg-opacity-75">Show/hide content</span>
      <svg [class.hidden]="!contentView()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" class="stroke-current text-yellow-200 hover:text-blue-600 w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
      </svg>
      <svg [class.hidden]="contentView()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" class="stroke-current text-yellow-200 hover:text-blue-600 w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{2}" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{2}"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268-2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    </button>

    <app-site-information [data]="data" [contentView]="contentView()" />
  </div>
</div>
}